<template>
  <!-- 课堂互动发布 -->
  <div class="staging-job">
    <a-form :form="formData" style="border:0px solid #f00; overflow:auto;">
      <div>
        <a-form-item label="作业标题" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <a-input
            v-decorator="[
              'title',
              {
                rules: [
                  { required: true, message: '作业标题不能为空' },
                  {
                    pattern: pattern,
                    message: '作业标题只能由字母、数字和中文组成',
                  },
                ],
              },
            ]"
            placeholder="请输入作业标题"
          />
        </a-form-item>

        <a-form-item label="作业备注" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <a-textarea
            v-decorator="['description', {}]"
            :maxLength="200"
            placeholder="请输入作业备注(最多可输入200字)"
            :rows="4"
          />
        </a-form-item>
      </div>
    </a-form>

    <div class="bottom-button">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" :loading="loading" @click="publishAssembly">确认</a-button>
    </div>
  </div>
</template>

<script>
import data from "../../../config/assemblyJson"
export default {
  name: 'staging-job',
  props: {
    pageList: {
      type: Array,
    },
  },

  inject: ["reload"],
  watch: {},
  data () {
    return {
      formData: {
        title: "",
        description: "",
      },
      loading: false,
      pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/g,
      struct: [],
      quesStructures: [],
    }
  },
  methods: {
    publishAssembly () {
      this.formData.validateFields(async (errors, values) => {
        console.log(errors, values)
        // console.log(this.struct)
        // console.log(this.formData)
        // console.log(this.formData.getFieldsValue())
        if (!errors) {
          this.loading = true
          let { data: res } = await this.$http.post(
            "/v1/learnonly/upload/savejob",
            {
              struct: JSON.stringify(this.struct),
              teacherid: this.$store.getters.id,
              description: this.formData.getFieldsValue().description
                ? this.formData.getFieldsValue().description
                : "",
              title: this.formData.getFieldsValue().title
                ? this.formData.getFieldsValue().title
                : "暂存作业至草稿箱",
            }
          )
          console.log(res)
          this.loading = false
          if (res.code != 200) return this.$message.error(res.message)
          this.$message.success(
            "作业 " + this.formData.getFieldsValue().title + " 已暂存至草稿箱"
          )
          this.reload()
        }
      })
    },
    cancel () {
      this.$emit("incre")
    },
  },
  created () {
    this.struct = data.struct
    // let pageList = localStorage.getItem("pageList")
    //   ? JSON.parse(localStorage.getItem("pageList"))
    //   : []

    if (!this.pageList || this.pageList.length == 0) {
      this.pageList = localStorage.getItem("pageList")
        ? JSON.parse(localStorage.getItem("pageList"))
        : []
    }

    this.pageList.forEach((q) => {
      let obj = {
        questionId: q.questionId,
        bankId: q.bankId,
        bankName: q.bankName,
        childNum: q.childNum,
        questionTypeId: q.questionTypeId,
        questionTypeName: q.questionTypeName,
        blankHeight: q.blankHeight,
        score: q.score,
        tip: q.tip,
        mark: q.mark,
      }
      if (obj && obj.questionId)
        this.quesStructures.push(obj)
    })
    this.struct.partStructures[0].sectionStructures[0].quesStructures = this.quesStructures
    // console.log(this.struct)
    this.formData = this.$form.createForm(this)
  },
}
</script>

<style scoped>
.staging-job {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.bottom-button {
  text-align: right;
}
.ant-form-item {
  margin-bottom: 5px;
  width: 90%;
}
</style>
